import axios from 'axios'
import authHeader from './auth-header'
// import moment from 'moment'
// const API = 'https://api.rededecisao.com/api/'

class NegociaService {

  getDebitosResp ( idPessoa ) {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/debitos/pendentes/${ idPessoa }`, { headers: authHeader() })
  }
  
  putCalculaDebitos(cpfResponsavel, mencodigos) {
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/calculadebitos`,{ cpf_responsavel_financeiro: cpfResponsavel, mencodigos: mencodigos},{ headers: authHeader() } )
  }

  getPoliticas () {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/politicas/0`, { headers: authHeader() })
  }

  getPolitica ( idPolitica ) {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/politica/${idPolitica}`, { headers: authHeader() })
  }

  getCampanhas () {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/campanhas/0`, { headers: authHeader() })
  }

  getAlunosFiltrados (options) {
    var { siglaUnidade, periodoLetivo, idCurso, serie, idTurma } = options

    idCurso = idCurso ?? 0
    serie = serie ?? 0
    idTurma = idTurma ?? 0

    return axios.get(process.env.VUE_APP_API_URL + `negocieja/publicos/filtrar/${siglaUnidade}/${periodoLetivo}/${idCurso}/${serie}/${idTurma}`,{ headers: authHeader() })
  }

  getCampanha( idCampanha ) {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/campanha/${idCampanha}`, { headers: authHeader() })
  }

  updateCampanha(idNegocieJaCampanha, data) {
    return axios.put(process.env.VUE_APP_API_URL + `negocieja/campanha/${idNegocieJaCampanha}`, data, { headers: authHeader() })
  }

  updatePolitica(idNegocieJaPolitica, data) {
    return axios.put(process.env.VUE_APP_API_URL + `negocieja/politica/${idNegocieJaPolitica}`, data, { headers: authHeader() })
  }
 
  createCampanha ( dadosCampanha ) {
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/campanha`, dadosCampanha, { headers: authHeader() })
  }

  createPolitica ( dadosPolitica ) {
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/politica`, dadosPolitica, { headers: authHeader() })
  }

  getPublicos (){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/publicos/0`, { headers: authHeader() })
  }

  getPagamentos (){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/formaspagamento/0`, { headers: authHeader() })
  }

  updatePagamentos ( idNegocieJaFormaPagamento, data ) {
    return axios.put(process.env.VUE_APP_API_URL + `negocieja/formapagamento/${idNegocieJaFormaPagamento}`, data, { headers: authHeader() })
  }

  updatePublicos ( idPublico, data ) {
    return axios.put(process.env.VUE_APP_API_URL + `negocieja/publico/${idPublico}`, data, { headers: authHeader() })
  }

  gerarProposta ( payload ) {
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/gerarpropostatermo`, payload, { headers: authHeader() })
  }

  createPublico(payload) {
  return axios.post(process.env.VUE_APP_API_URL + `negocieja/publico`, payload, { headers: authHeader() })
  }

  createPagamentos (payload){
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/formapagamento`, payload, { headers: authHeader() })
  }

  getBloqueios (){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/tipos/bloqueio/matriculas`, { headers: authHeader() })
  }
  
  getEfetivadas ( ){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/efetivadas/0`, { headers: authHeader() })
  }

  getEfetivadasDetalhes ( idNegocieJaProposta ){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/efetivadas/${idNegocieJaProposta}`, { headers: authHeader() })
  }

  getEfetivada ( nome ){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/efetivadas/filtrar/${nome}`, { headers: authHeader() })
  }

  getEfetivadasFiltro (query = '') {
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/efetivadas/filtrar${query}`, { headers: authHeader() })
  }

  getRenegociadas ( idNegocieJaProposta ){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/renegociadas/${idNegocieJaProposta}`, { headers: authHeader() })
  }

  getBloqueioNegociacao ( idPessoa ){
    return axios.get(process.env.VUE_APP_API_URL + `negocieja/bloqueios/${idPessoa}`, { headers: authHeader() })
  }

  getDebitos ( data ){
    return axios.post(process.env.VUE_APP_API_URL + `negocieja/calculadebitos`, data, { headers: authHeader() })
  }

  getProposta ( uuid ){
    return axios.get(process.env.VUE_APP_API_URL + `negocie/get/proposta/uuid/${uuid}`, { headers: authHeader() })
  }

  getContrato ( uuid ) {
    // {{urlApi}}/api/negocieja/get/contrato/docusign/uuid/:uuid
    return axios.get(process.env.VUE_APP_API_URL + `negocie/get/contrato/docusign/uuid/${uuid}`, { headers: authHeader() })
    // return axios.get(process.env.VUE_APP_API_URL + `negocieja/get/contrato/docusign/uuid/${uuid}`, { headers: authHeader() })
  }

  signContrato ( idContrato ) {
    return axios.post(process.env.VUE_APP_API_URL + `negocie/get/getcontrato/${idContrato}`, {}, { headers: authHeader() })
  }

  negociar ( payload ) {
    return axios.post(process.env.VUE_APP_API_URL + `negocie/pagar/baixar`, payload, { headers: authHeader() })
  }
}

export default new NegociaService()